import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.reviewops.company.summary');
import { Input } from '@angular/core';

interface CompanySummaryData {
    name?: string;
    founded_year?: number;
}

@Component({
    selector: 'wiz-component-reviewops-company-summary',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.reviewops.company.summary/view.scss */
/* src/app/component.reviewops.company.summary/view.scss: no such file or directory */`],
})
export class ComponentReviewopsCompanySummaryComponent {
    @Input() company: CompanySummaryData = {};
    @Input() latestYear: number | null = null;
    @Input() datasetName: string = 'Sample Peer Dataset';
}

export default ComponentReviewopsCompanySummaryComponent;